import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/login/Login.vue';
import Password from './components/login/RecuperarPassword.vue';
import Problemas from './components/login/ProblemasIniciar.vue';
import ExpirationModal from './components/principal/ExpirationModal.vue';
import Maintenance from './components/principal/Maintenance.vue';
import Reservaciones from './components/principal/views/Reservaciones.vue';
import ReservacionesRegistro from './components/principal/views/ReservacionesRegistro.vue';
import ReservacionesMetodosPago from './components/principal/views/ReservacionesMetodosPago.vue';
import Contacto from './components/principal/views/Contacto.vue';
import InformacionCorporate from './components/principal/views/InformacionCorporate.vue';
import InformacionAdicional from './components/principal/views/InformacionAdicional.vue';
import ModificacionReservaciones from './components/principal/views/ModificacionReservaciones.vue';
import AclaracionReservaciones from './components/principal/views/AclaracionReservaciones.vue';
import CancelarReservacion from './components/principal/views/CancelarReservacion.vue';
import ReservacionesCancelacion from './components/principal/views/ReservacionesCancelacion.vue';
import ReservacionesCancelada from './components/principal/views/ReservacionesCancelada.vue';
import ReservacionesConfirmacion from './components/principal/views/ReservacionesConfirmacion.vue';
import ReservacionesModificacion from './components/principal/views/ReservacionModificacion';
import BusquedaPorTarifa from './components/principal/views/BusquedaPorTarifa.vue';
import BusquedaAvanzada from './components/principal/views/BusquedaAvanzada.vue';
import BusquedaSeguimiento from './components/principal/views/BusquedaSeguimiento.vue';
import MovimientosDia from './components/principal/views/MovimientosDia.vue';
import AdministracionUsuarios from './components/administracionUsuarios/AdministracionUsuarios.vue';
import InformacionPersonalEditar from './components/administracionUsuarios/InformacionPersonalEditar.vue';
import Error from './components/principal/views/Error.vue';
import Error2 from './components/principal/views/Error2.vue';
import ReservacionesModificacionLectura from './components/principal/views/ReservacionModificacionLectura';
import PerfilHuespedes from './components/principal/views/PerfilHuespedes.vue';
import TerminosCondiciones from './components/principal/views/TerminosCondiciones.vue';
import * as GlobalFunctions from "../../corporate-front/src/utils/GlobalFunctions";
import axios from 'axios'
import SecureLS from 'secure-ls'

Vue.use(Router)

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  // mode: 'history',
  routes: [
    {
      path: '/session-expired',  
      name: 'ExpirationModal',
      component: ExpirationModal
    },
    {
      path: '/maintenance',  
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/terminos-condiciones',  
      name: 'TerminosCondiciones',
      component: TerminosCondiciones
    },
    {
      path: '/perfil-huespedes',   
      name: 'PerfilHuespedes',
      component: PerfilHuespedes,
      meta: { requiresAuth: true }

    },
    {
      path: '/error/corporate', 
      name: 'Error2',
      component: Error2
    },
    {
      path: '/error',  
      name: 'Error',
      component: Error
    },
    {
      path: '/login',  
      name: 'Login',
      component: Login
    },
    {
      path: '/login?lang=EN',  
      name: 'LoginIdioma',
      component: Login
    },
    {
      path: '/recuperar-contrasena',  
      name: 'Password',
      component: Password,

    },
    {
      path: '/problemas-para-inicar', 
      name: 'Problemas',
      component: Problemas
    },
    {
      path: '/',
      name: 'Reservaciones',  
      component: Reservaciones,
      meta: { requiresAuth: true }
    },
    {
      path: '/reservaciones-registro',   
      name: 'ReservacionesRegistro',
      component: ReservacionesRegistro,
      meta: { requiresAuth: true }

    },
    {
      path: '/reservaciones-metodos-pago',  
      name: 'ReservacionesMetodosPago',
      component: ReservacionesMetodosPago,
      meta: { requiresAuth: true }

    },
    {
      path: '/reservaciones-confirmacion',   
      name: 'ReservacionesConfirmacion',
      component: ReservacionesConfirmacion,
      meta: { requiresAuth: true }

    },
    {
      path: '/reservaciones-cancelacion', 
      name: 'ReservacionesCancelacion',
      component: ReservacionesCancelacion,
      meta: { requiresAuth: true }

    },
    {
      path: '/reservaciones-modificar',   
      name: 'ReservacionesModificacion',
      component:ReservacionesModificacion,
      meta: { requiresAuth: true }

    },
    {
      path: '/reservaciones-modificar-lectura', 
      name: 'ReservacionesModificacionLectura',
      component: ReservacionesModificacionLectura,
      meta: { requiresAuth: true }

    }, 
    {
      path: '/reservaciones-cancelada',  
      name: 'ReservacionesCancelada',
      component: ReservacionesCancelada,
      meta: { requiresAuth: true }

    },
    {
      path: '/contacto',  
      name: 'Contacto',
      component: Contacto
    },
    {
      path: '/informacion-corporate', 
      name: 'InformacionCorporate',
      component: InformacionCorporate,
      meta: { requiresAuth: true }

    },
    {
      path: '/informacion-adicional', 
      name: 'InformacionAdicional',
      component: InformacionAdicional,
      meta: { requiresAuth: true }

    },
    {
      path: '/modificacion-reservaciones',  
      name: 'ModificacionReservaciones',
      component: ModificacionReservaciones,
      meta: { requiresAuth: true }

    },
    {
      path: '/cancelar-reservaciones',   
      name: 'CancelarReservacion',
      component: CancelarReservacion,
      meta: { requiresAuth: true }

    },
    {
      path: '/aclaracion-reservaciones',    
      name: 'AclaracionReservaciones',
      component: AclaracionReservaciones,
      meta: { requiresAuth: true }

    },
    {
      path: '/busqueda-por-tarifa',  
      name: 'BusquedaPorTarifa',
      component: BusquedaPorTarifa,
      meta: { requiresAuth: true }

    }, // BusquedaAvanzada  BusquedaSeguimiento 
    {
      path: '/busqueda-avanzada',  
      name: 'BusquedaAvanzada',
      component: BusquedaAvanzada,
      meta: { requiresAuth: true }

    },
    {
      path: '/busqueda-seguimiento',  
      name: 'BusquedaSeguimiento',
      component: BusquedaSeguimiento,
      meta: { requiresAuth: true }

    },
    // Administacion de usuarios
    {
      path: '/movimientos-del-dia',  
      name: 'MovimientosDia',
      component: MovimientosDia,
      meta: { requiresAuth: true }

    },
    
    {
      path: '/administracion-de-usuarios',  
      name: 'AdministracionUsuarios',
      component: AdministracionUsuarios,
      meta: { requiresAuth: true }

    },
    {
      path: '/administracion-de-usuarios/informacion-personal',  
      name: 'InformacionPersonalEditar',
      component: InformacionPersonalEditar,
      meta: { requiresAuth: true }

    },
  ]
})


router.beforeEach((to, from, next) => {
  var ls = new SecureLS({encodingType: 'aes'});
  var token = ls.get('Token').data;
  if (to.matched.some(record => record.meta.requiresAuth)) {  // Requires auth? Yes, do something
    GlobalFunctions.tokenExistValidate().then(response => {   // Token exists? Yes, do something
      if(!response){
        GlobalFunctions.localStorageClean();
        next({
          name: "ExpirationModal"   // Token exists? NO, go expired
        });
      } else{   // Token exists? Yes, do something
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_VALTOK, {},  {
          headers: {'Authorization': 'Bearer ' + token,
            'Content-Type' : 'application/json',
          }
        })
        .then(res => {
          if(res.status == 200 || res.status == 201) {
            next();   // Token exists and is valid? Yes, keep routing
          }
        })
        .catch(error => {   // Token exists is valid? No, do something
       //   if(error.response.status == 401) {
            axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_VALTOK, {},  {
              headers: {'Authorization': 'Bearer ' + token,
                'Content-Type' : 'application/json',
              }
            })
            .then(res => {
              if(res.status == 200 || res.status == 201) {
                next();       // Token exists is valid? Yes, keep routing
              }
            })
            .catch(error => {
          //    if(error.response.status == 401) {
                next({
                  name: "ExpirationModal"   // Token exists is valid? No, go expired
                });
         //     }
            })
       //   }
        })    // Token exists is valid? No, do something
      }     // Token exists? Yes, do something
    })      // Token exists? Yes, do something
  } else {  // Requires auth? No, allow routing
    next();
  }
});

export default router
